import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MuscoBrandProvider } from "../theme/MuscoBrandProvider";
import { SidebarMusco } from "./SidebarMusco";

/**
 * Layout principal P3 — sidebar fija 230px + columna principal con scroll.
 *
 * El ThemeToggle vive dentro de cada vista (las páginas P3 lo colocan
 * en su header propio); así siempre es visible y accesible. La sidebar
 * tiene logo + nav + pipeline + user chip dropdown.
 */
export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <MuscoBrandProvider>
      <div
        className="musco-app-shell"
        style={{
          display: "grid",
          gridTemplateColumns: "230px 1fr",
          minHeight: "100vh",
          background: "var(--musco-bg)",
          color: "var(--musco-text)",
        }}
      >
        <SidebarMusco />
        <main
          id="main-content"
          className="min-w-0 overflow-x-hidden px-5 pt-2"
          style={{ background: "var(--musco-bg)" }}
        >
          <ErrorBoundary FallbackComponent={Error}>
            <Suspense
              fallback={
                <div className="p-8">
                  <Skeleton className="h-12 w-1/3 rounded-md" />
                </div>
              }
            >
              {children}
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
      <Notification />
    </MuscoBrandProvider>
  );
};
